import 'regenerator-runtime/runtime';
import 'ol/ol.css';
import Geolocation from 'ol/Geolocation';
import {fromLonLat} from 'ol/proj';

let interval;

// punt d'entrada
window.addEventListener('load', (event) => {
    init();
});

function init() {
  el('boto').addEventListener("click", toggle_start, true);
}

function toggle_start() {
  let but = el('boto');
  if (but.value=="start") {
    but.value = "stop";
    but.innerHTML = "STOP";
    geolocation.setTracking(true);
    interval = setInterval(() => printar(), 1000);
  } else {
    geolocation.setTracking(false);
    clearInterval(interval);
    but.value = "start";
    but.innerHTML = "START";
  }
}

function printar() {
  const coordinates = geolocation.getPosition();
  //console.log(coordinates);
  let info = el('info');
  let cad = formatDate(new Date()) + "<br />";
  cad = cad + "(" + coordinates[0] + "," + coordinates[1] + ")";
  info.innerHTML = cad;
}


const geolocation = new Geolocation({
  // enableHighAccuracy must be set to true to have the heading value.
  trackingOptions: {
    enableHighAccuracy: true,
  },
  projection: 'EPSG:4326'
});

function el(id) {
  return document.getElementById(id);
}

// handle geolocation error.
geolocation.on('error', function (error) {
  const info = document.getElementById('info');
  info.innerHTML = error.message;
  info.style.display = '';
});

function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

function formatDate(date) {
  let dia = [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join('/');

  let hora = [
    padTo2Digits(date.getHours()),
    padTo2Digits(date.getMinutes()),
    padTo2Digits(date.getSeconds()),
  ].join(':');

  return dia + " " + hora;
}

//funció calcularDistancia(item) definida a ArbresBarcelonaRN
